import script from "./Loader.vue?vue&type=script&setup=true&lang=ts"
export * from "./Loader.vue?vue&type=script&setup=true&lang=ts"

import "./Loader.vue?vue&type=style&index=0&id=646ef839&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-646ef839"]])

export default __exports__